import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { tokens } from '@companycam/slab';

// #region styled components
const StyledImg = styled.img`
  height: ${tokens.size_spacing_m}px;
  width: ${tokens.size_spacing_m}px;
  object-fit: contain;
`;
// #endregion

const IntegrationIcon = ({ integrationPackage }) => {
  if (integrationPackage.iconUrl) {
    return (
      <StyledImg
        src={integrationPackage.iconUrl}
        alt={`${integrationPackage.name} Logo`}
      />
    );
  }
  else if (integrationPackage.logoUrl) {
    return (
      <StyledImg
        src={integrationPackage.logoUrl}
        alt={`${integrationPackage.name} Logo`}
      />
    );
  }

  return <i className="mdi mdi-puzzle-outline" />;
};

IntegrationIcon.propTypes = {
  integrationPackage: PropTypes.shape({
    logoUrl: PropTypes.string,
    iconUrl: PropTypes.string,
    name: PropTypes.string.isRequired,
  }),
};

export default IntegrationIcon;
